import React, {useEffect, useState} from 'react';
import {Loader} from "@aws-amplify/ui-react";

const Vimeo = ({
  onError,
  url,
}) => {
  const [videoData, setVideoData] = useState();

  useEffect(() => {
    const request = new Request(
      `https://vimeo.com/api/oembed.json?url=${url}&responsive=true&pip=true`,
      {
        credentials: "omit",
      }
    );
    fetch(request)
      .then(response => response.json())
      .then(setVideoData);
  }, [url])

  if (!videoData) {
    return (
      <div 
        style={{
          minHeight: 60,
        }}
      >
        <Loader size="large" />
      </div>
    );
  }

  const {
    html = null,
  } = videoData || {};

  if (!html) {
    return onError();
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};

export default Vimeo;